import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = ["element", "className", "children", "fluid", "free", "size", "soft", "clearfix"];

var Container = function Container(_ref) {
  var _classnames;

  var element = _ref.element,
      className = _ref.className,
      children = _ref.children,
      fluid = _ref.fluid,
      free = _ref.free,
      size = _ref.size,
      soft = _ref.soft,
      clearfix = _ref.clearfix,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var Element = element;
  return /*#__PURE__*/React.createElement(Element, _extends({}, rest, {
    className: classnames('ln-o-container', (_classnames = {}, _classnames["ln-o-container--" + size] = size, _classnames['ln-o-container--soft'] = typeof soft === 'boolean' && soft, _classnames["ln-o-container--soft-" + soft] = typeof soft === 'string', _classnames['ln-o-container--fluid'] = fluid, _classnames['ln-o-container--free'] = free, _classnames['ln-o-clearfix'] = clearfix, _classnames), className)
  }), children);
};

Container.propTypes = {
  element: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.string]),
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.string,
  soft: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  fluid: PropTypes.bool,
  free: PropTypes.bool,
  clearfix: PropTypes.bool
};
Container.defaultProps = {
  element: 'div',
  children: undefined,
  className: undefined,
  size: undefined,
  soft: undefined,
  fluid: false,
  free: false,
  clearfix: false
};
Container.displayName = 'Container';
var _excluded$1 = ["element", "className", "children", "alignment"];

var FlagBody = function FlagBody(_ref) {
  var _classnames;

  var element = _ref.element,
      className = _ref.className,
      children = _ref.children,
      alignment = _ref.alignment,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  var Element = element;
  return /*#__PURE__*/React.createElement(Element, _extends({}, rest, {
    className: classnames(className, 'ln-o-flag__body', (_classnames = {}, _classnames["ln-o-flag__body--" + alignment] = alignment, _classnames))
  }), children);
};

FlagBody.displayName = 'FlagBody';
FlagBody.propTypes = {
  element: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  alignment: PropTypes.oneOf(['top', 'bottom'])
};
FlagBody.defaultProps = {
  element: 'div',
  className: undefined,
  alignment: undefined
};
var _excluded$2 = ["element", "className", "children", "alignment", "nowrap"];

var FlagComponent = function FlagComponent(_ref) {
  var _classnames;

  var element = _ref.element,
      className = _ref.className,
      children = _ref.children,
      alignment = _ref.alignment,
      nowrap = _ref.nowrap,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$2);

  var Element = element;
  return /*#__PURE__*/React.createElement(Element, _extends({}, rest, {
    className: classnames(className, 'ln-o-flag__component', (_classnames = {}, _classnames["ln-o-flag__component--" + alignment] = alignment, _classnames['ln-o-flag__component--nowrap'] = nowrap, _classnames))
  }), children);
};

FlagComponent.displayName = 'FlagComponent';
FlagComponent.propTypes = {
  element: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  alignment: PropTypes.oneOf(['top', 'bottom']),
  nowrap: PropTypes.bool
};
FlagComponent.defaultProps = {
  element: 'div',
  className: undefined,
  alignment: undefined,
  nowrap: false
};
var _excluded$3 = ["element", "className", "children", "respondAt"];

var FlagWrapper = function FlagWrapper(_ref) {
  var element = _ref.element,
      className = _ref.className,
      children = _ref.children,
      respondAt = _ref.respondAt,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$3);

  var Element = element;
  return /*#__PURE__*/React.createElement(Element, _extends({}, rest, {
    className: classnames(className, !respondAt && 'ln-o-flag', respondAt && "ln-o-flag@" + respondAt)
  }), children);
};

FlagWrapper.displayName = 'FlagWrapper';
FlagWrapper.propTypes = {
  element: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  respondAt: PropTypes.string
};
FlagWrapper.defaultProps = {
  element: 'div',
  className: undefined,
  respondAt: undefined
};
var _excluded$4 = ["element", "className", "children", "size", "offsetLeft", "offsetRight"];

var responsiveClassName = function responsiveClassName(className, prefix) {
  if (prefix === void 0) {
    prefix = '';
  }

  return className && (typeof className === 'object' ? Object.keys(className).map(function (breakpoint) {
    return breakpoint !== 'default' ? "ln-u-" + prefix + className[breakpoint] + "@" + breakpoint : "ln-u-" + prefix + className[breakpoint];
  }) : "ln-u-" + prefix + className);
};

var GridItem = function GridItem(_ref) {
  var element = _ref.element,
      className = _ref.className,
      children = _ref.children,
      size = _ref.size,
      offsetLeft = _ref.offsetLeft,
      offsetRight = _ref.offsetRight,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$4);

  var Element = element;
  return /*#__PURE__*/React.createElement(Element, _extends({}, rest, {
    className: classnames(className, 'ln-o-grid__item', responsiveClassName(size), responsiveClassName(offsetLeft, 'pull-'), responsiveClassName(offsetRight, 'push-'))
  }), children);
};

GridItem.displayName = 'GridItem';
GridItem.propTypes = {
  element: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,

  /** Width of item as a fraction value, can supply an object with responsive values */
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,

  /** Push content by either a static or responsive fractions */
  offsetLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),

  /** Push content by either a static or responsive fractions */
  offsetRight: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};
GridItem.defaultProps = {
  element: 'div',
  className: undefined,
  offsetLeft: undefined,
  offsetRight: undefined
};
var _excluded$5 = ["className", "children", "matrix", "reverse", "equalHeight", "gutterSize", "verticalAlign", "horizontalAlign", "element"];

var GridWrapper = function GridWrapper(_ref) {
  var _classnames;

  var className = _ref.className,
      children = _ref.children,
      matrix = _ref.matrix,
      reverse = _ref.reverse,
      equalHeight = _ref.equalHeight,
      gutterSize = _ref.gutterSize,
      verticalAlign = _ref.verticalAlign,
      horizontalAlign = _ref.horizontalAlign,
      element = _ref.element,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$5);

  var Element = element;
  return /*#__PURE__*/React.createElement(Element, _extends({}, rest, {
    className: classnames(className, 'ln-o-grid', (_classnames = {
      'ln-o-grid--matrix': matrix,
      'ln-o-grid--reverse': reverse,
      'ln-o-grid--equal-height': equalHeight
    }, _classnames["ln-o-grid--gutter-" + gutterSize] = gutterSize, _classnames["ln-o-grid--" + verticalAlign] = verticalAlign, _classnames["ln-u-text-align-" + horizontalAlign] = horizontalAlign, _classnames))
  }), children);
};

GridWrapper.displayName = 'GridWrapper';
GridWrapper.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  matrix: PropTypes.bool,
  gutterSize: PropTypes.string,
  reverse: PropTypes.bool,
  equalHeight: PropTypes.bool,
  verticalAlign: PropTypes.oneOf(['middle', 'center', 'bottom']),
  horizontalAlign: PropTypes.oneOf(['center', 'right']),
  element: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
};
GridWrapper.defaultProps = {
  className: undefined,
  matrix: false,
  gutterSize: undefined,
  reverse: false,
  equalHeight: false,
  verticalAlign: undefined,
  horizontalAlign: undefined,
  element: 'div'
};
export { Container, FlagBody, FlagComponent, FlagWrapper, GridItem, GridWrapper };